import SignMinus from './images/icon-minus.svg';
import SignPlus from './images/icon-plus.svg';
import SignEquals from './images/icon-equals.svg';

const SIGNS = {
  minus: { src: SignMinus, alt: 'Minus' },
  equals: { src: SignEquals, alt: 'Equals' },
  plus: { src: SignPlus, alt: 'Plus' }
};

export default function AccountingEquation({ 
  firstSign = 'equals', 
  secondSign = 'plus' 
}) {
  return (
    <div className="transition-elements-formula">
      <div className="transition-element" style={{ backgroundColor: '#EBF2FF' }}>Assets</div>
      <img src={SIGNS[firstSign].src} alt={SIGNS[firstSign].alt} />
      <div className="transition-element" style={{ backgroundColor: '#FFF8EB' }}>Liabilities</div>
      <img src={SIGNS[secondSign].src} alt={SIGNS[secondSign].alt} />
      <div className="transition-element" style={{ backgroundColor: '#ECF6F7' }}>Equity</div>
    </div>
  );
}